import { z } from 'zod';

import { cepDigits } from '@escala/domain/members';

import { request } from './http';

/**
 * Endereço pelo CEP, no serviço público ViaCEP (https://viacep.com.br) — chamado do
 * navegador, sem passar pela API. É só conveniência: sem internet ou com o serviço fora,
 * a pessoa digita o endereço.
 */
const ViaCepSchema = z.union([
  z.object({ erro: z.union([z.literal(true), z.literal('true')]) }),
  z.object({
    logradouro: z.string(),
    bairro: z.string(),
    localidade: z.string(),
    uf: z.string(),
  }),
]);

export interface CepAddress {
  street: string;
  district: string;
  city: string;
  uf: string;
}

/** O endereço do CEP (8 dígitos), `null` se não existe ou se o serviço não respondeu. */
export async function lookupCep(cep: string): Promise<CepAddress | null> {
  const digits = cepDigits(cep);

  if (digits.length !== 8) return null;

  try {
    const data = await request(`https://viacep.com.br/ws/${digits}/json/`, {
      schema: ViaCepSchema,
      timeoutMs: 8000,
    });

    if ('erro' in data) return null;

    return { street: data.logradouro, district: data.bairro, city: data.localidade, uf: data.uf };
  } catch {
    return null;
  }
}
